import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import http from "../api/http";
import Filter from "../types/filter";
import Tile from "../types/tile";

interface FilterState {
  filters?: Filter[];
  status: "idle" | "loading" | "failed";
}

const initialState: FilterState = {
  status: "idle",
};

export const getFilters = createAsyncThunk<Filter[], Tile>(
  "filters/fetch",
  async (tile: Tile) => {
    const connectionIds: number[] =
      tile.connections
        ?.map((c) => c.id)
        .filter((id): id is number => id !== undefined) || [];

    let url = `/filter/${tile.dataType?.id}?tileTypeId=${tile.type?.id}`;

    if (!!tile.reportType && !!tile.reportType.id) {
      url += `&reportTypeId=${tile.reportType?.id}`;
    }

    const response = await http.post<Filter[]>(url, connectionIds);
    return response.data;
  }
);

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    clearFilters(state) {
      state.filters = initialState.filters;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFilters.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getFilters.fulfilled, (state, action) => {
        state.status = "idle";
        state.filters = action.payload;
      })
      .addCase(getFilters.rejected, (state, action) => {
        state.status = "failed";
      });
  },
});

export const { clearFilters } = filterSlice.actions;

export default filterSlice.reducer;
